exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".google-maps[data-v-427c52da] {\n  width: 100%;\n  height: 310px;\n}", ""]);

// exports
